import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "../../../../environments/environment";
import { CommonSelectionInterface } from "../../interface/common.interface";
import { getProductTypeLabel } from "../../constants/celcomdigi/product-type";
import { getPolicyStatusLabel } from "../../constants/celcomdigi/policy-status";
import { getClaimStatusLabel } from "../../constants/celcomdigi/claim-status";
import { getTravelAreaLabel } from "../../constants/celcomdigi/travel-area";
import { CelcomdigiPolicyDetail, CelcomdigiPolicyListing, CelcomdigiPolicyClaimListing } from "../../interface/personal-protection/pp-celcomdigi.interface"

@Injectable({
	providedIn: "root",
})
export class PersonalProtectionDataService {
	private basePathCelcomdigiPolicy = `${environment.url}/api/CDPolicy/`;
	private basePathCelcomdigiClaim = `${environment.url}/api/CDClaim/`;

	constructor(private http: HttpClient) { }

	getCelcomdigiClaimStatusList(): CommonSelectionInterface[] {
		return [
			{ id: "New", name: "New" },
			{ id: "Processing", name: "Processing" },
			{ id: "Approved", name: "Approved" },
			{ id: "Rejected", name: "Rejected" }
		];
	}

	getCelcomdigiPolicyStatusList(): CommonSelectionInterface[] {
		return [
			{ id: "Active", name: "Active" },
			{ id: "Expired", name: "Expired" },
			{ id: "Cancelled", name: "Cancelled" }
			//{ id: "Refunded", name: "Refunded" },
			//{ id: "Lapsed", name: "Lapsed" }
		];
	}

	getPolicyStatusList(): CommonSelectionInterface[] {
		return [
			{ id: "Active", name: "Active" },
			{ id: "Deactivated", name: "Deactivated" }
		];
	}

	getCelcomdigiClaimTypeList(): CommonSelectionInterface[] {
		return [
			{ id: "Accidental Death/Permanent Disablement", name: "Accidental Death/Permanent Disablement" },
			{ id: "Auto Loan Protect", name: "Auto Loan Protect" },
			{ id: "Bill Protection", name: "Bill Protection" },
			{ id: "Hospital Income", name: "Hospital Income" },
			{ id: "Hospitalisation", name: "Hospitalisation" },
			{ id: "Loss of Employment", name: "Loss of Employment" },
			{ id: "Loss/Damage to Personal Luggage/Effects", name: "Loss/Damage to Personal Luggage/Effects" },
			{ id: "Luggage Delay", name: "Luggage Delay" },
			{ id: "Medical Expenses", name: "Medical Expenses" },
			{ id: "Travel Delay", name: "Travel Delay" },
			{ id: "Trip Cancellation/Curtailment", name: "Trip Cancellation/Curtailment" }
		]
	}

	// CelcomDigi Policy Listing
	getCelcomdigiPolicyListing(
		limit: number,
		offset: number,
		text: string,
		columnIndex: number,
		sortDirection: string,
		startDate: Date,
		endDate: Date,
		policyStatusList?: string[],
		claimStatusList?: string[]
	) {
		return this.http.post<{
			count: number;
			data: CelcomdigiPolicyListing[];
		}>(`${this.basePathCelcomdigiPolicy}GetListing`, {
			limit,
			offset,
			text,
			columnIndex,
			sortDirection,
			startDate,
			endDate,
			policyStatusList,
			claimStatusList
		})
			.pipe(
				map((res) => ({
					count: res.count,
					data: res.data.map((d) => ({
						...d,
						UI_productType: getProductTypeLabel(d.productType),
						UI_status: getPolicyStatusLabel(d.status),
						UI_claimStatus: getClaimStatusLabel(d.claimStatus)
					}))
				}))
			);;
	}

	// CelcomDigi Policy Details
	getCelcomdigiPolicyDetails(id: string): Observable<CelcomdigiPolicyDetail> {
		return this.http.get<CelcomdigiPolicyDetail>(
			`${this.basePathCelcomdigiPolicy}GetDetails/${id}`
		)
			.pipe(
				map((res) => ({
					...res,
					UI_productType: getProductTypeLabel(res.productType),
					UI_status: getPolicyStatusLabel(res.status),
					UI_destination: getTravelAreaLabel(res.destination)
				}))
			);
	}

	// CelcomDigi Policy Claim Listing
	getCelcomdigiPolicyClaimListing(
		id: string,
		text: string,
		columnIndex: number,
		sortDirection: string,
		claimStatusList: string[],
		claimTypeList: string[]
	) {
		return this.http
			.post<CelcomdigiPolicyClaimListing[]>(
				`${this.basePathCelcomdigiClaim}GetClaimListingByPolicyId`,
				{
					policyId: id,
					text,
					columnIndex,
					sortDirection,
					claimTypeList,
					claimStatusList
				}
			)
			.pipe(
				map((res) =>
					res.map((pol) => ({
						...pol,
						UI_claimStatus: getClaimStatusLabel(pol.claimStatus),
						UI_claimType: pol.claimType.join(", ")
					}))
				)
			);
	}

	deactivatePolicy(id: string, values: any) {
		return this.http.post(
		  `${this.basePathCelcomdigiPolicy}DeactivatePolicy/${id}`,
		  values
		);
	  }
}
